import { useCallback, useEffect, useState } from 'react';

import { getServiceFeeEligibility, postServiceFeeEligibility } from 'Services/privateApis';

type UseServiceFeeEligibilityProps = {
  dpEnquiryId?: number;
  enabled?: boolean;
};

type UseServiceFeeEligibilityReturn = {
  isEnquiryEligibleForServiceFee: boolean;
  setEligibility: () => void;
};

export const useServiceFeeEligibility = ({
  dpEnquiryId,
  enabled = false,
}: UseServiceFeeEligibilityProps = {}): UseServiceFeeEligibilityReturn => {
  const [isEnquiryEligibleForServiceFee, setIsEnquiryEligibleForServiceFee] = useState(false);

  useEffect(() => {
    if (!enabled || !dpEnquiryId) {
      return;
    }

    getServiceFeeEligibility(dpEnquiryId)
      .then((response: { eligible?: boolean }) => {
        setIsEnquiryEligibleForServiceFee(Boolean(response?.eligible));
      })
      .catch(() => {
        setIsEnquiryEligibleForServiceFee(false);
      });
  }, [enabled, dpEnquiryId]);

  const setEligibility = useCallback(() => {
    if (!dpEnquiryId) {
      return;
    }

    postServiceFeeEligibility(dpEnquiryId).catch(() => {});
  }, [dpEnquiryId]);

  return { isEnquiryEligibleForServiceFee, setEligibility };
};
